import getSymbolFromCurrency from 'currency-symbol-map';
import Dinero from 'dinero.js';

export const formatCurrencyLabel = (currency) =>
  `${currency.toUpperCase()}  ${getSymbolFromCurrency(currency)}`;

export const formatCurrency = ({ amount, currency, noDecimals = false }) => {
  if (!amount && amount !== 0) {
    return '';
  }

  try {
    return Dinero({ amount: Math.round(amount * 100), currency })
      .setLocale('fr')
      .toFormat(noDecimals ? '$0,0' : undefined)
      .toUpperCase();
  } catch (err) {
    // An unknown or missing currency must still print a readable amount:
    // the raw float would leak its binary rounding (609.6800000000001).
    const numericAmount = Number(amount);

    return Number.isFinite(numericAmount)
      ? numericAmount.toFixed(noDecimals ? 0 : 2)
      : amount;
  }
};
